import { render, staticRenderFns } from "./teman-hannah.html?vue&type=template&id=3f637df6&scoped=true&"
import script from "./teman-hannah.js?vue&type=script&lang=js&"
export * from "./teman-hannah.js?vue&type=script&lang=js&"
import style0 from "./teman-hannah.css?vue&type=style&index=0&id=3f637df6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f637df6",
  null
  
)

export default component.exports